<template>
  <v-app>
    <TopBar v-if="topBarEnabledRoutePaths.indexOf($route.path) > -1"></TopBar>

    <v-content class="content">
      <router-view></router-view>
    </v-content>
    <v-footer color="transparent" class="footer">
      <v-col class="text-center" cols="12">
        <div class="demo-note" v-if="demoEnvironmentEnabled">
          PLEASE NOTE: This is a demo site only, please do not enter any personal information.
          Information entered here may be deleted at any time.
        </div>
        <div>
          &copy;2019-2020 CompliSpace (<span id="composite-version">v{{ compositeVersion }}</span
          >). All rights reserved.
        </div>
      </v-col>
    </v-footer>
  </v-app>
</template>

<style scoped>
.footer {
  font-size: 12px;
  color: #cccccc;
}

.content {
  background: white;
}
</style>

<script>
import TopBar from './components/TopBar';

import routeName from './lib/const/routeName';
import storeAction from './lib/const/storeAction';
import systemEvent from './lib/const/systemEvent';

/**
 * These are required to ensure they are included in the webpack dist build
 * Non-downloadable file names need to be camelCased
 */
/* eslint-disable import/no-unresolved */
require('public/favicon.svg');
require('public/ideagen_compliSpace_vertical.svg');
require('public/CompliCare.png');
require('public/logo-cs.png');
require('public/PolicyConnect.png');
require('public/StbHorizontalLogo.png');
require('public/CompliSpacePrimary.png');
/* eslint-enable import/no-unresolved */

export default {
  name: 'App',

  components: {
    TopBar
  },

  data() {
    return {
      topBarEnabledRoutePaths: [
        '/',
        '/about',
        '/login',
        '/logout',
        '/thank-you',
        '/users',
        '/users/info',
        '/users/new'
      ],

      apiVersion: '',
      authTokenRefreshAttempted: false,
      authTokenRefreshActionInProgress: false
    };
  },
  computed: {
    compositeVersion() {
      const { bundleVersion } = this.$app.packageJson;
      const uiVersion = this.$app.packageJson.version;
      const localApiVersion = this.apiVersion ? `-${this.apiVersion}` : '';

      return `${bundleVersion}#${uiVersion}${localApiVersion}`;
    },

    demoEnvironmentEnabled() {
      return this.$app.env.APP_ENV === 'demo';
    }
  },
  methods: {
    async handleAuthStrategyEnforcementResponse(sessionUser) {
      if (sessionUser) {
        this.authTokenRefreshAttempted = false;
        this.$store.dispatch(storeAction.SET_SESSION_USER, sessionUser);
      } else if (!this.authTokenRefreshAttempted && !this.authTokenRefreshActionInProgress) {
        this.authTokenRefreshAttempted = true;
        this.authTokenRefreshActionInProgress = true;
        const refreshToken = this.$app.authCommonAdapter.getRefreshToken();

        if (refreshToken) {
          await this.$store.dispatch(storeAction.GET_USER_AUTH_REFRESH).catch(() => {
            this.$app.authCommonAdapter.invalidateRefreshToken();
          });
        }

        this.authTokenRefreshActionInProgress = false;
        this.$app.authCommonAdapter.enforceUserAuthStrategy(this.$route, true);
      }
    }
  },

  async mounted() {
    if (routeName.THANK_YOU_CONTENT !== this.$route.name) {
      const that = this;

      this.$app.eventBus.$on(
        systemEvent.AUTH_STRATEGY_ENFORCEMENT_DONE,
        that.handleAuthStrategyEnforcementResponse
      );

      this.$app.authCommonAdapter.enforceUserAuthStrategy(this.$route, false);
    }

    this.apiVersion = await this.$store.dispatch(storeAction.GET_HEALTH_ALIVE);
  },

  beforeDestroy() {
    this.$app.eventBus.$off(systemEvent.AUTH_STRATEGY_ENFORCEMENT_DONE);
  }
};
</script>
